import * as types from '../actions/action-types';
import _ from 'lodash';

const stateFipsKey = 'sf';
const stateNameKey = 'sn';
const stateAbbrKey = 'sa';

const defaults = {
  loading: true,
  loadingPct: true,
  selected: {
    name: 'Alabama',
    abbr: 'AL',
    fips: 1
  },
  percentiles: [],
  list: [],
  data: [],
  dict: {},
  averages: {}
};

/**
 * Set Selected state and create state level data (counties)
 *
 * @param store
 * @param stateFips
 */
function setState(store, stateFips) {
  const state = store.dict[+stateFips];

  // Fail safe
  if (!state){
    return store;
  }

  const selected = _.assign({}, state, {
    name: state[stateNameKey],
    fips: state[stateFipsKey],
    abbr: state[stateAbbrKey]
  });

  return {
    ...store,
    selected
  };
}

/**
 * Create States list for selection controls
 *
 * @param data
 */
function getStateList(data) {
  return _.chain(data)
    .map(state => {
      return {
        name: state[stateNameKey],
        fips: state[stateFipsKey],
        abbr: state[stateAbbrKey]
      }
    })
    .filter(s => s.fips && s.fips !== 99)
    .uniqBy('fips')
    .orderBy('name')
    .value();
}

/**
 * Set initial data and loading false
 *
 * @param store
 * @param data
 */
function setData(store, data) {
  return {
    ...store,
    loading: false,
    data: _.filter(data, s => s.sf !== 99),
    dict: _.keyBy(data, stateFipsKey),
    list: getStateList(data)
  };
}

function setPercentileData(store, data) {
  return {
    ...store,
    loadingPct: false,
    percentiles: _.filter(data, s => s.sf !== 99),
    percentileDict: _.keyBy(data, stateFipsKey),
  };
}

function setAverageData(store, data) {
  const first = _.first(data);

  return {
    ...store,
    averages: first
  };
}

function clearData(store) {
  return {
    ...store,
    // loading: true,
    loadingPct: true
  };
}

export default (store = defaults, action) => {
  switch (action.type) {
    case types.SELECT_STATE:
      return setState(store, action.stateFips);
    case types.NATIONAL_DATA_RECEIVED:
      return setData(store, action.data);
    case types.NATIONAL_PCT_DATA_RECEIVED:
      return setPercentileData(store, action.data);
    case types.NATIONAL_AVG_DATA_RECEIVED:
      return setAverageData(store, action.data);
    case types.GET_NATIONAL_DATA:
      return clearData(store);
    default:
      return store;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducers/states-reducer.js